<!-- Auth0 doesn't know whether anyone's signed in until isLoading$ goes
     false — on a cold load (e.g. an invoice link opened straight from an
     email) that can take a beat, during which every guarded route's
     canActivate is still pending and the router hasn't activated anything
     yet. Hold the router-outlet behind the same spinner post-login-page
     already uses for its own "wait to know where to send the reader" gap,
     rather than showing a blank page for that wait. -->
<div
    *ngIf="authService.isLoading$ | async; else appShell"
    class="vb-spinner-box vb-spinner-box--page"
>
    <vb-spinner size="xl" label="Loading"></vb-spinner>
</div>
<ng-template #appShell>
    <app-masquerade-banner></app-masquerade-banner>
    <div [class.has-masquerade-banner]="masqueradeService.isMasquerading()">
        <router-outlet></router-outlet>
    </div>
</ng-template>

<!-- Single global snackbar outlet (@viewbid/ui), replacing ngx-toastr's
     toast container. Mounted once at the true app root — outside
     LayoutComponent — so it also covers the bare /login, /post-login, and
     404 routes, not just layout-wrapped pages. Left at its default
     centering (no offsetLeft/offsetRight/offsetBlock) rather than tuned to
     this app's sidebar/bid-rail widths — revisit if it visually collides
     with either. -->
<vb-snackbar-host></vb-snackbar-host>
